import React from 'react'

// constants
import aampeTheme from '../../../constants/aampeTheme'

import NestedError from '../../errors/NestedError'
// components
import Spinner from '../../loading/nestedSpinner'

export default function BasicSection({
    children,
    style = {},
    isLoading = false,
    isError = false,
    error = '',
    belowTabs = false,
}) {
    return (
        <div
            style={{
                backgroundColor: aampeTheme.colors.white,
                borderRadius: aampeTheme.borderRadius.default,
                padding: belowTabs
                    ? aampeTheme.spacing4(0, 1, 1, 1)
                    : aampeTheme.spacing4(2, 2),
                borderTopLeftRadius: belowTabs
                    ? 0
                    : aampeTheme.borderRadius.default,
                ...style,
                height: '100%',
            }}
        >
            {isLoading ? (
                <Spinner style={{ minHeight: '250px' }} />
            ) : isError ? (
                <NestedError style={{ minHeight: '400px' }} errorMsg={error} />
            ) : (
                children
            )}
        </div>
    )
}
